import { Dispatch, SetStateAction, useState, useEffect } from 'react';
import { useWeb3Modal } from '@web3modal/wagmi/react';
import { useSignMessage, useAccount } from 'wagmi';

import { SidebarModal } from '../../../components';

import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
// import { Step4 } from './Step4';

import { ConnectWallet } from '../../FlipMeWallet/FlipMeBanner';
import { RedeemFlipmeCardsStepsEnum } from './types';
import { Step4 } from './Step4';

interface RedeemFlipmeCardsProps {
  packageId?: number | null;
  redeemCardsModal: boolean;
  setRedeemCardsModal: Dispatch<SetStateAction<boolean>>;
  redeemFlipmeCardsStep: RedeemFlipmeCardsStepsEnum;
  setRedeemFlipmeCardsStep: Dispatch<
    SetStateAction<RedeemFlipmeCardsStepsEnum>
  >;
}

export const RedeemFlipmeCards = ({
  packageId,
  redeemCardsModal,
  setRedeemCardsModal,
  redeemFlipmeCardsStep,
  setRedeemFlipmeCardsStep
}: RedeemFlipmeCardsProps) => {
  const [walletAddress, setWalletAddress] = useState<string>('');

  const redeemFlipmeCardsSteps = (step: RedeemFlipmeCardsStepsEnum) => {
    switch (step) {
      case RedeemFlipmeCardsStepsEnum.STEP1:
        return (
          <Step1
            setRedeemFlipmeCardsStep={setRedeemFlipmeCardsStep}
            setRedeemCardsModal={setRedeemCardsModal}
            packageId={packageId}
          />
        );

      case RedeemFlipmeCardsStepsEnum.STEP2:
        return (
          <Step2
            setRedeemFlipmeCardsStep={setRedeemFlipmeCardsStep}
            setRedeemCardsModal={setRedeemCardsModal}
            walletAddress={walletAddress}
            setWalletAddress={setWalletAddress}
            packageId={packageId}
          />
        );

      case RedeemFlipmeCardsStepsEnum.STEP3:
        return (
          <Step3
            packageId={packageId}
            setRedeemCardsModal={setRedeemCardsModal}
          />
        );

      case RedeemFlipmeCardsStepsEnum.STEP4:
        return (
          <Step4
            packageId={packageId}
            setRedeemCardsModal={setRedeemCardsModal}
          />
        );

      default:
        break;
    }
  };

  return (
    <div>
      <SidebarModal
        isOpen={redeemCardsModal}
        setOpen={(v) => setRedeemCardsModal(!redeemCardsModal)}
        title='Activate Your FlipMe Card'
        sidebarWidth={'560px'}>
        {redeemFlipmeCardsSteps(redeemFlipmeCardsStep)}{' '}
      </SidebarModal>
    </div>
  );
};
